/**
 * @desc cache
 */
import * as lodash from './lodash';
export function cacheFunction(compute, maxCacheSize) {
    if (maxCacheSize === void 0) { maxCacheSize = 10; }
    var cacheValueList = [];
    var cachedInputList = [];
    return (function () {
        var input = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            input[_i] = arguments[_i];
        }
        var cacheIndex = lodash.findIndex(cachedInputList, function (prevInput) {
            return (prevInput &&
                prevInput.length === input.length &&
                prevInput.every(function (item, index) { return item === input[index]; }));
        });
        if (cacheIndex >= 0) {
            return cacheValueList[cacheIndex];
        }
        if (cacheValueList.length > maxCacheSize) {
            cacheValueList.shift();
            cachedInputList.shift();
        }
        var value = compute.apply(null, input);
        cacheValueList.push(value);
        cachedInputList.push(input);
        return value;
    });
}
